import { NgClass } from "@angular/common";
import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from "@angular/router";
import { IconModule, slideDownUp } from "@crm-workspace/common-lib";
import { Store } from "@ngrx/store";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgScrollbarModule } from "ngx-scrollbar";
import { filter } from "rxjs/operators";
import { PropertyBookingsWorkspaceService } from "../services/property-bookings-workspace.service";
import { readApiErrorMessage } from "../utils/api-error.util";

@Component({
  selector: "sidebar",
  templateUrl: "./sidebar.html",
  animations: [slideDownUp],
  imports: [
    NgClass,
    RouterLink,
    NgScrollbarModule,
    RouterLinkActive,
    TranslateModule,
    IconModule,
  ],
})
export class SidebarComponent implements OnInit {
  active = false;
  store: any;
  activeDropdown: string[] = [];
  parentDropdown: string = "";
  private readonly destroyRef = inject(DestroyRef);
  private readonly propertyBookingsWorkspace = inject(
    PropertyBookingsWorkspaceService,
  );
  propertyBookingsMenuError: string | null = null;

  constructor(
    public translate: TranslateService,
    public storeData: Store<any>,
    public router: Router
  ) {}

  initStore() {
    this.storeData
      .select((d) => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }

  ngOnInit(): void {
    this.initStore();
    this.syncAccordionFromUrl();
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => this.syncAccordionFromUrl());
  }

  syncAccordionFromUrl(): void {
    const path = this.router.url.split("?")[0];
    const open: string[] = [];
    if (path.includes("/property-bookings")) {
      open.push("property-bookings");
    }
    if (path.includes("/post-sales")) {
      open.push("post-sales");
    }
    this.activeDropdown = open;
  }

  toggleMobileMenu() {
    if (window.innerWidth < 1024) {
      this.storeData.dispatch({ type: "toggleSidebar" });
    }
  }

  toggleAccordion(name: string, parent?: string) {
    if (this.activeDropdown.includes(name)) {
      this.activeDropdown = this.activeDropdown.filter((d) => d !== name);
    } else {
      this.activeDropdown.push(name);
    }
  }

  onPropertyBookingsMenuClick(): void {
    const isOpen = this.activeDropdown.includes("property-bookings");
    if (isOpen) {
      this.toggleAccordion("property-bookings");
      return;
    }

    this.propertyBookingsMenuError = null;
    this.propertyBookingsWorkspace.prepareSectionAccess().subscribe({
      next: (granted) => {
        if (granted && !this.activeDropdown.includes("property-bookings")) {
          this.activeDropdown.push("property-bookings");
        }
      },
      error: (err: unknown) => {
        this.propertyBookingsMenuError = readApiErrorMessage(
          err,
          "Failed to load builders.",
        );
      },
    });
  }
}
